import React, { memo } from 'react';
import AbsoluteError from 'components/AbsoluteError';

const SignupError = memo(({ t }) => {
    return (
        <div className="signup__error">
            <AbsoluteError
                title={t('error_generalerror')}
                subtitle={t('error_technical_error_creating_account')}
            />
        </div>
    );
});

export default SignupError;
